import { Pipe, PipeTransform } from '@angular/core';
import { DateChecker } from '../model/dateValidation.model';

@Pipe({
    name: 'dateChecker',
})
export class DateCheckerPipe implements PipeTransform {
    transform(dateString: string): DateChecker {
        let newValue: DateChecker;
        const desiredValue = dateString.substring(dateString.indexOf(':') + 1).trim();
        if (dateString) {
            const dateTimeWithSecondsRegex = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}$/;
            const dateTimeWithoutSecondsRegex = /^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/;

            // Check if the desiredValue matches the date formats strictly
            const isValidDateFormat = dateTimeWithSecondsRegex.test(desiredValue) || dateTimeWithoutSecondsRegex.test(desiredValue);

            if (isValidDateFormat) {
                newValue = {
                    isDate: true,
                    value: desiredValue
                };
            } else {
                newValue = {
                    isDate: false,
                    value: desiredValue
                };
            }
        } else {
            newValue = {
                isDate: false,
                value: desiredValue
            };
        }
        return newValue;
    }
}